import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setEnableDateRange: YJSChangeHandler<
  DatabaseChangeType.SET_DATE_FIELD_ENABLE_DATE_RANGE
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.enableDateRange = change.enableDateRange;
  });
};
